import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { DataResponse } from '../models/data-response.model';
import { HttpService } from './http.service';
import { TypographyTheme } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TypographyApiService {
  private cache = { themes: null };

  constructor(private readonly httpService: HttpService) { }

  public getTypographyThemes(): Observable<DataResponse<TypographyTheme>> {
    if (!this.cache.themes) {
      this.cache.themes = this.httpService.get<DataResponse<TypographyTheme>>('style/themes')
        .pipe(
          shareReplay({ bufferSize: 1, refCount: true }),
          catchError(err => {
            this.cache.themes = null;
            throw err;
          })
        );
    }

    return this.cache.themes;
  }
}
